var partnersFgts = document.querySelectorAll('.js-partners.splide')

if (partnersFgts) {
    partnersFgts.forEach(partnersFgt => {
        var gap = 24;

        var splideInstance = null;

        function initSlider() {

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            splideInstance = new Splide(partnersFgt, {
                perMove: 1,
                autoWidth: true,
                drag: 'free',
                gap: `${gap / 16}rem`,
                snap: true,
                pagination: false
            });

            splideInstance.on('overflow', function (isOverflow) {

                splideInstance.go(0);

                splideInstance.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                };
            });

            splideInstance.mount();
        }

        // Init au chargement
        initSlider();

        // Reinit au resize (avec debounce)
        var resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                initSlider();
            }, 200);
        });
    })
}